import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseExpert() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getExpertList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ExpertReview?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        response.data.resault.products.map((model) => {
          model.id = model.productID;
          return model;
        });
        callback(response.data.resault);
      }
    });
  };

  const getAllExpertList = (callback) => {
    MyAxios.get(`Admin_ExpertReview?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getExpertByID = (id, callback) => {
    MyAxios.get(`Admin_ExpertReview/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateExpert = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_ExpertReview`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("نقد و بررسی با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addExpert = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ExpertReview`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("نقد و بررسی با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteExpert = (id, callback) => {
    const data = new FormData();
    data.append("ProductID", id);
    MyAxios.delete(`Admin_ExpertReview`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("نقد و بررسی با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const GetExpertImages = (ExpertID, callback) => {
    MyAxios.get(`Admin_ExpertReview/Image/${ExpertID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddExpertImage = (Model, file, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    data.append("Image", file);
    MyAxios.post(`Admin_ExpertReview/Image`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("افزودن تصویر باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteExpertImage = (ImageID, callback) => {
    const data = new FormData();
    data.append("ImageID", ImageID);
    MyAxios.delete(`Admin_ExpertReview/Image`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف تصویر باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    getExpertList,
    getAllExpertList,
    getExpertByID,
    updateExpert,
    addExpert,
    deleteExpert,
    GetExpertImages,
    AddExpertImage,
    DeleteExpertImage,
  };
}
